const state = {
	inventoryReportIntention: false,
	serviceOrderReportIntention: false,
	assortmentReportIntention: false,
}

const mutations = {
	generateInventoryReport: (state, generate) => {
		state.inventoryReportIntention = generate
	},

	generateServiceOrderReport: (state, generate) => {
		state.serviceOrderReportIntention = generate
	},

	generateAssortmentReport: (state, generate) => {
		state.assortmentReportIntention = generate
	},
}

const getters = {
	getInventoryReportIntention: (state) => state.inventoryReportIntention,
	getServiceOrderReportIntention: (state) => state.serviceOrderReportIntention,
	getAssortmentReportIntentation: (state) => state.assortmentReportIntention,
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
}
